import { inject, Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, EMPTY, Observable, throwError } from 'rxjs';
import { Store } from '@ngxs/store';
import { Logout } from '../../security/actions/auth-actions';

@Injectable()
export class KeepAliveInterceptor implements HttpInterceptor {
  private readonly store = inject(Store);

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.store.dispatch(new Logout());

          return EMPTY;
        }
        return throwError(error);
      })
    );
  }
}
